import DOMPurify from 'dompurify';

export const sanitize = (content: string) => {
  const s = DOMPurify.sanitize(content);
  return s.replace(/style='[^']*'/g, '').replace(/style="[^"]*"/g, '');
};
